
import { computed, defineComponent, getCurrentInstance, onActivated, onDeactivated, ref, watch } from 'vue';
import { useLogin } from '~/hooks/useLogin';
import SideBar from '../side-bar/index.vue';
import LoginPopup from '@/components/login/index.vue';
import LogoutPopup from '@/components/logout-popup/index.vue';

const AIBaseLayout = defineComponent({
    components: {
        SideBar,
        LoginPopup,
        LogoutPopup,
    },
    setup() {
        const { proxy } = getCurrentInstance() || {};

        const isActivated = ref(false);

        const {
            showLoginPopup,
            showLogoutPopup,
            isLoginStatus,

            handleLoginPopupClose,
            changeLoginStatus,
            handleLoginPopupOpenkwai,
            changeLoginPopupShow,
            handleLogout,
            handleLogoutCancel,
            handleLogoutPopupShow,
        } = useLogin();

        const onPopupShowStatusChange = (show: boolean) => {
            proxy?.$store?.commit?.('popupModule/setShowSideBar', show);
        };

        const showSideBar = computed(() => proxy?.$store?.state?.popupModule?.showSideBar || false);

        watch(
            () => proxy?.$store?.state?.popupModule?.loginPopupFlag,
            () => {
                if (document.visibilityState === 'visible' && isActivated.value) {
                    changeLoginPopupShow(true);
                }
            }
        );

        watch(
            () => proxy?.$store?.state?.popupModule?.logoutPopupFlag,
            () => {
                if (document.visibilityState === 'visible' && isActivated.value) {
                    handleLogoutPopupShow(true);
                }
            }
        );

        onActivated(() => {
            isActivated.value = true;
        });

        onDeactivated(() => {
            isActivated.value = false;
        });

        return {
            showLoginPopup,
            showLogoutPopup,
            isLoginStatus,
            showSideBar,

            handleLoginPopupClose,
            changeLoginStatus,
            handleLoginPopupOpenkwai,
            changeLoginPopupShow,
            handleLogout,
            handleLogoutCancel,
            handleLogoutPopupShow,
            onPopupShowStatusChange,
        };
    },
});

export default AIBaseLayout;
